export const ORG_ROLES = ['owner', 'accountant', 'bookkeeper', 'viewer'] as const;
export type OrgRole = (typeof ORG_ROLES)[number];

export type OrgMembership = {
  orgId: string;
  orgName: string;
  role: OrgRole;
};

export function canManageTeam(role: OrgRole): boolean {
  return role === 'owner' || role === 'accountant';
}

export function canManageUsers(role: OrgRole): boolean {
  return role === 'owner';
}

export function canPostDocuments(role: OrgRole): boolean {
  return role !== 'viewer';
}
